import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae2fadaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-window__main" }
const _hoisted_2 = { class: "modal-window__header" }
const _hoisted_3 = { class: "modal-window__title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "modal-window__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["modal-window", `modal-window--${_ctx.type}`])
        }, [
          _createElementVNode("div", {
            class: "modal-window__bg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
              _createElementVNode("button", {
                title: _ctx.$t('ui-close'),
                class: "modal-window__close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("main", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}